var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"main-header",attrs:{"height":"60px"}},[_c('el-row',{staticClass:"main-header__row",attrs:{"type":"flex","justify":"space-between","align":"bottom"}},[_c('el-col',[_c('TabsNavigation')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }